var _style, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneWebTechnologiesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 924.7 323.5",
    style: {
      enableBackground: "new 0 0 924.7 323.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#20163F;} .st1{fill:url(#SVGID_1_);} .st2{fill:url(#SVGID_2_);} .st3{fill:url(#SVGID_3_);} ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "One_WEb"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M739.3,81c5.6-1.7,11.2-3.5,16.8-5.2V114c4.7-3.6,10.2-6.4,16.1-7.3c8.7-1.4,18.2,0.4,25.2,6.1 c14.3,11.8,14.4,36.7,7,50.6c-4.8,9-13.5,15.5-22.9,18.8c-12.3,4.3-31.3,3.1-42.2-0.1L739.3,81z M756,124.6l0,46.4 c4.6,1,9.3,1.7,14,1.1c9.3-1.1,17.6-8.3,20.4-17.3c2.5-8.3,2-23.3-4.8-30.2C777.6,116.6,765.7,118.7,756,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381,110.7c6.3,15.3,5.9,39-5.8,54c-26.3,34.1-83.3,20.7-87.4-25.4C282,73.2,362.1,64.3,381,110.7z M332.2,94.1c-35,4.3-37.1,65.8-5.3,75.8c18.1,5.7,34-5.2,39.3-23C373.9,120.6,359.2,90.8,332.2,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M591,84.8c5.8,0,11.6,0,17.4,0c7,28,13.9,56,21,83.9l20.4-83.9c5.5,0,11,0,16.5,0l-26.8,98.4 c-7,0-13.9,0-20.9,0l-19-76.6c-6.5,25.5-12.8,51.1-19.3,76.7c-6.9-0.1-13.8,0-20.7,0l-26.6-98.4c5.5,0,11,0,16.5,0l20.4,84 L591,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.1,109.4c11.8-2.6,23.7,2.3,26.5,14.1c1.1,4.8,0.9,4.9,0.9,59.7l-16.1,0c0-52.9,0.7-53.9-2.3-58 c-2.3-3.2-6.5-4.2-10.2-3.8c-6.7,0.7-12.7,4.3-18,8.2c-0.1,17.9,0,35.8,0,53.6h-16.1l0-72.9l15.7,0c0,3.1,0,6.1,0,9.2 C419.3,115,425.8,111,433.1,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.7,112.5c13.7-7.6,35.7-4.2,42.9,12.7c3.2,7.6,3,16.1,3,24.2l-47.5,0c0.8,23.5,21.5,28.7,41.9,18.2 c1.9,3.4,3.7,6.7,5.5,10.1c-8.9,6.2-28.9,10.3-43.5,4.4c-17-6.8-23.1-25.3-20-44C473.8,127.5,480.2,117.7,489.7,112.5z M497.3,122.8c-5.5,3.6-8.5,10.1-9,16.5c10.4,0,20.7,0,31.1,0c-0.3-5.3-1.3-10.9-5-14.9C510.1,119.8,502.4,119.4,497.3,122.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M680.6,112.5c11.2-6.3,29.8-5.4,39.1,6.1c8.1,10,6.7,22.7,6.9,30.8l-47.5,0c1.3,23.5,21.2,28.8,41.9,18.2 c1.9,3.3,3.7,6.7,5.5,10.1c-4.6,3.2-10.1,4.9-15.5,6c-24.6,5.3-41.7-5.2-46.9-22.9C658.9,143.1,663.9,122,680.6,112.5z M679.4,139.4l31,0C709.6,111.9,681.1,116.5,679.4,139.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.9,236.8c-3.9-4-9.9-5-15.2-4.2c-6.9,1.1-13,4.8-18.6,8.8l0-32.2l-8.5,2.4l0,79.7c2.8,0,5.7,0,8.5,0 c0-14.6,0-29.3,0-43.9c5.1-3.8,10.7-7.2,17.1-8.2c9.1-1.4,12.7,3.1,12.9,12.1l0,40.1l8.5,0l0-41.1 C503.6,245.4,502.5,240.2,498.9,236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M647.2,211.6l0,79.7l8.7,0l0-82.2C652.9,210,650.1,210.8,647.2,211.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "345.8,213.3 293.6,213.3 293.6,220.1 315.2,220.1 315.2,291.4 324.3,291.4 324.3,220.1 345.8,220.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M799.5,213.3v11.5l8.5,0c0-3.8,0-7.7,0-11.5C805.2,213.3,802.3,213.3,799.5,213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.1,252.2c-3.5-29.2-44.9-25.8-48,5.6c-2.4,21.1,9.2,34.5,25.2,34.9c7.9,0.3,16.2-1.2,22.9-5.5 c-1-1.8-2.1-3.6-3.1-5.4c-8.8,5.1-22.9,6.5-30.1-0.7c-4.7-4.6-6.7-11.4-6.6-17.9l40,0C393.3,259.6,393.5,255.9,393.1,252.2z M353.5,257.2c2.4-20.2,22.4-23,28.5-11.7c1.9,3.6,2.4,7.7,2.6,11.7C374.2,257.3,363.9,257.3,353.5,257.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.1,284.5c-11.3-4.6-15-20.4-10.6-32.2c5-12.7,16.6-16.4,28.5-10.8c1-2.1,2.1-4.2,3.1-6.3 c-7.7-3.6-16.9-4-24.9-0.8c-15.3,6.3-21,24.3-16,39.7c5.4,16.9,25.2,22.9,41.3,15.6c-1-1.9-2-3.8-2.9-5.7 C437.8,286.5,431,286.9,425.1,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M559.9,236.8c-3.9-3.9-9.8-5.1-15.1-4.3c-7,1-13.2,4.8-18.8,8.9c0-2.6,0-5.1,0-7.7c-2.8,0-5.6,0-8.4,0l0,57.6 c2.8,0,5.7,0,8.5,0c0-14.7-0.1-29.3,0-44c5.4-3.9,11.4-7.6,18.2-8.3c3.3-0.4,7.1,0.2,9.3,3c3.2,4.2,2.5,6.3,2.5,49.3h8.5l0-41.1 C564.5,245.5,563.4,240.3,559.9,236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M618.4,235.1c-9.6-4.7-23.9-3.9-32.5,5.4c-10.8,11.3-10.2,31.1-1.4,42.2c8.4,10.8,22.9,12.1,32.3,8.1 C638.2,281.7,639.9,245.9,618.4,235.1z M613.2,284.6c-4.8,2-10.6,2-15.4-0.2c-10.7-4.9-15.9-25.4-5.9-38.6 c6.4-8.9,19.6-8.9,26.1-1.8C630.1,257.4,624.7,279.7,613.2,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M675.6,242.6c-11.7,14.9-6.8,43,13.2,49c22.8,6.4,40.1-12.8,35.9-36C720.4,229.5,688.4,225.4,675.6,242.6z M715.7,269.7c-1.4,5.5-4.2,11-9.2,14c-7.2,4-17.5,2.9-22.6-3.8c-11.5-15.1-4.3-38.7,10.5-40.7 C710.6,236.6,719.4,254.6,715.7,269.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M764.3,233c-23.7-6-37.4,22.1-20.1,35.6c-7.7,5.2-11.3,14.3-3.6,19.4c-2.7,1.8-5.4,3.7-7.2,6.4 c-2.8,4.1-2.4,9.9,0.7,13.7c6.1,7.5,17.4,8.6,27,8.2c6.6-0.4,13.3-2.2,18.6-6.4c7.2-5.5,8-16,3.8-20.9c-3.1-3.6-8-4.8-12.6-5.2 c-7-0.6-14.1-1-21.1-1.6c-4.2-0.4-7-1.8-5.6-5.7c0.9-2.2,2.9-3.7,4.8-5c13.4,5.4,27.8-1.7,30.8-13.3c1.4-6.1,0-12.8-3.9-17.8 c3.6,0,7.2,0,10.8,0l0-6.6C765.1,233.7,768.6,234.1,764.3,233z M746.5,289.8c7.4,0.4,14.8,1,22.2,1.5c2.6,0.2,5.7,0.6,7.5,2.8 c2,2.5,1.5,6.3-0.1,8.9c-5.4,8.6-26.7,8.3-33.6,2.1c-2.4-2.2-3-5.9-1.7-8.8C741.8,293.6,744.2,291.6,746.5,289.8z M768.8,261.7 c-5,6.9-17.2,6.6-21.6-0.9c-2.3-3.9-2.6-8.9-1.3-13.3c3.1-10,16.7-11,22.2-4.4C772.3,248.3,772.6,256.3,768.8,261.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M853.9,233.6c-19.1-6.6-38.6,9.5-34.1,36.7c1.3,7.8,5.8,15.4,12.8,19.2c9.8,5.4,25.8,3.5,35-2.2 c-1-1.9-2-3.7-3.1-5.5c-10,5.8-25.3,6.5-32.2-3.2c-3.2-4.5-4.5-10-4.6-15.4c13.4,0,26.7,0,40.1,0c0-5.4,0.3-10.9-1.3-16.2 C864.5,241,859.9,235.8,853.9,233.6z M827.9,257.3c2.4-19.2,20.3-22.4,27.1-13.8c3.1,3.8,3.8,9,4,13.8H827.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M917,272.1c-1-3.5-3.7-6.3-6.6-8.3c-6.5-4.4-14.8-5.5-20.8-10.7c-5-4.4-3.6-12.4,5.2-13.9 c6.2-0.9,12.5,0.8,17.9,3.9c1.1-2.1,2.2-4.2,3.2-6.3c-7.4-4-16.2-5.6-24.5-3.8c-15.9,3.7-19,22.4-1,30.2c5.7,2.5,16.5,5.9,18,12.1 c3.3,10.6-15,14.9-27.6,5.7l-3.4,6.8c10.8,6.5,28.9,7.2,36.9-2.4C917.3,281.9,918.2,276.7,917,272.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M799.5,291.4l8.5,0v-57.6c-2.8,0-5.7,0-8.5,0V291.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000179614359030472433840000010922440888044619943_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.9833,
    y1: 251.9641,
    x2: 77.7333,
    y2: 29.5891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C0BDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#6E6782"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8294,
    style: {
      stopColor: "#362D52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20163F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.3,201.2c-20.7,20.9-49.4,33.9-81.2,33.9c-50.2,0-92.9-32.5-108.1-77.6c-2-7.4-3.1-15.2-3.1-23.2 c0-48.7,39.7-88.2,88.6-88.2c29,0,54.8,13.9,70.9,35.4c-11.4-14-28.8-22.9-48.3-22.9c-29.1,0-53.6,20-60.4,46.9 c-3.1,9-4.8,18.7-4.8,28.8c0,48.7,39.7,88.2,88.6,88.2C166.6,222.7,186.8,214.6,202.3,201.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.9321,
    y1: 7.2276,
    x2: 158.4321,
    y2: 191.7276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C0BDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    style: {
      stopColor: "#6E6782"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7122,
    style: {
      stopColor: "#362D52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8587,
    style: {
      stopColor: "#20163F"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.9,134.4c0,8,1.1,15.8,3.1,23.2c-3.9-11.5-6-23.8-6-36.6C7,58.1,57.9,7.1,120.8,6.9 c48.8,0.2,88.3,39.6,88.3,88.2c0,47.3-37.4,86-84.4,88.1c32.8-1.8,58.8-29,58.8-62.2c0-8.7-1.8-17.1-5-24.6v0 c-2.3-5.4-5.4-10.4-9-14.8c-16.2-21.5-41.9-35.4-70.9-35.4C49.5,46.2,9.9,85.7,9.9,134.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.077,
    y1: 32.2689,
    x2: 43.452,
    y2: 219.3939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C0BDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    style: {
      stopColor: "#6E6782"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7122,
    style: {
      stopColor: "#362D52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8587,
    style: {
      stopColor: "#20163F"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M121.1,6.9c63,0,114.1,51.1,114.1,114.1c0,31.2-12.6,59.5-32.9,80.2c0,0,0,0,0,0 c-15.5,13.4-35.8,21.5-57.9,21.5c-48.9,0-88.6-39.5-88.6-88.2c0-10.1,1.7-19.8,4.8-28.8c-1.2,4.9-1.9,10.1-1.9,15.4 c0,11.5,10.7,65.5,65.9,62.2c47-2.1,84.4-40.8,84.4-88.1c0-48.6-39.5-88.1-88.3-88.2C120.9,6.9,121,6.9,121.1,6.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneWebTechnologiesLogo);
export default __webpack_public_path__ + "static/media/OneWeb-Technologies-Logo.3293053d011ffd78dc32defc3eddfca0.svg";
export { ForwardRef as ReactComponent };